import resources from '../../resources'

import computed from './computed'
import mounted from './mounted'
import methods from './methods'

export default {
  mixins: [resources],

  computed,
  mounted,
  methods
}



// WEBPACK FOOTER //
// ./src/crud/form/resources/index.js